import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useEffect, useState } from "react";
import useNNEvidenceValidations, {
  ValidationResult,
} from "./hooks/useValidations";
import { NNEvidenceData, NNEvidenceInvalid } from "@/api/nn-evidence";
import { CheckCircle2, XCircleIcon } from "lucide-react";

export default function NNEvidenceValidations({
  checkingProfileId,
  nnEvidence,
  nnEvidenceInvalids,
  setStatusValidation,
}: {
  checkingProfileId?: string;
  nnEvidence?: NNEvidenceData;
  nnEvidenceInvalids?: NNEvidenceInvalid[];
  setStatusValidation?: React.Dispatch<React.SetStateAction<string>>;
}) {
  const [expanded, setExpanded] = useState<string>();
  const { requiredList, unrequiredList, overallStatus } =
    useNNEvidenceValidations({
      checkingProfileId,
      nnEvidenceInvalids: nnEvidenceInvalids ?? [],
      nnEvidence,
    });

  useEffect(() => {
    if (setStatusValidation) {
      setStatusValidation(overallStatus);
    }
  }, [overallStatus, setStatusValidation]);

  return (
    <Accordion
      type="single"
      value={expanded}
      onValueChange={setExpanded}
      collapsible
      className="w-full"
    >
      <AccordionItem value={"checkingProfile"}>
        <AccordionTrigger>
          <span className="flex gap-2 dark:text-neutral-300">Validations</span>
        </AccordionTrigger>
        <AccordionContent className="flex gap-x-2">
          <div className="flex flex-col gap-y-2">
            <div>
              <span className="font-semibold">
                Must Pass Before Processing:
              </span>
              <ul className="ml-4 list-inside">
                {requiredList.length > 0 &&
                  requiredList?.map((item: ValidationResult) => (
                    <ValidationListItem key={item.id} item={item} />
                  ))}
                {requiredList.length === 0 && <li>No required validations.</li>}
              </ul>
            </div>

            <div>
              <span>Can Be Checked Later:</span>
              <ul className="ml-4 list-inside">
                {unrequiredList.length > 0 &&
                  unrequiredList?.map((item: ValidationResult) => (
                    <ValidationListItem key={item.id} item={item} />
                  ))}
                {unrequiredList.length === 0 && <li>No validations.</li>}
              </ul>
            </div>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}

function ValidationListItem(props: { item: ValidationResult }) {
  const { item } = props;

  return (
    <li className="flex items-center justify-start gap-2">
      <span>{item.name}</span>
      <span>
        {item.isValid && item.isValid !== null && (
          <CheckCircle2 size={16} className="text-green-500" />
        )}{" "}
        {!item.isValid && item.isValid !== null && (
          <XCircleIcon size={16} className="text-red-500" />
        )}
      </span>
    </li>
  );
}
